import Toast from "../common/Toast/Toast";

const DownloadFileCustomName = async (url, filename) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Error downloading file:", error);
    Toast({
      type: "error",
      title: "Download Error",
      message: "Failed to download the file",
    });
  }
};

export default DownloadFileCustomName;
